export default __webpack_public_path__ + "static/media/default_img_no_data.8b3ed1fd.png";